"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Str = exports.Fonts = exports.Styles = exports.TextStyles = exports.Sizes = exports.Colors = exports.theme = void 0;
const colors_1 = __importDefault(require("./colors"));
exports.Colors = colors_1.default;
const sizes_1 = __importDefault(require("./sizes"));
exports.Sizes = sizes_1.default;
const textStyles_1 = __importDefault(require("./textStyles"));
exports.TextStyles = textStyles_1.default;
const styles_1 = __importDefault(require("./styles"));
exports.Styles = styles_1.default;
const fonts_1 = __importDefault(require("./fonts"));
exports.Fonts = fonts_1.default;
const components_1 = __importDefault(require("./components"));
const strings_json_1 = require("./strings.json");
Object.defineProperty(exports, "Str", { enumerable: true, get: function () { return strings_json_1.strings; } });
const native_base_1 = require("native-base");
exports.theme = (0, native_base_1.extendTheme)({
    colors: {
        ...colors_1.default,
        black: "#000000",
    },
    space: {
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        10: 10,
        12: 12,
        16: 16,
        20: 20,
        24: 24,
        32: 32,
        40: 40,
        48: 48,
        56: 56,
        64: 64,
        72: 72,
        80: 80,
        96: 96,
    },
    sizes: {
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        10: 10,
        12: 12,
        16: 16,
        20: 20,
        24: 24,
        32: 32,
        40: 40,
        48: 48,
        56: 56,
        64: 64,
        72: 72,
        80: 80,
        96: 96,
    },
    components: components_1.default,
});
const appTheme = { Colors: colors_1.default, Sizes: sizes_1.default, TextStyles: textStyles_1.default, Styles: styles_1.default, Fonts: fonts_1.default, Str: strings_json_1.strings };
exports.default = appTheme;
